module.exports = new __parcel__URL__("funnelPup.ca202fc2.svg").toString();